module.exports = __webpack_public_path__ + "img/20230210123829563yot.de29ff77.png";